import * as apiv2 from '../apiv2';

const getUsersRequest = () => ({
    type: 'GET_USERS_REQUEST'
});

const getUsersSuccess = data => ({
    type: 'GET_USERS_SUCCESS',
    data
});

const getUsersFailure = error => ({
    type: 'GET_USERS_FAILURE',
    error
});


export function getUserList() {
    return (dispatch, getState) => {
        const { informedWebApp } = getState();

        dispatch(getUsersRequest());
        return apiv2.getUserList(informedWebApp)
            .then(result => {
                dispatch(getUsersSuccess(result));
            })
            .catch(error => dispatch(getUsersFailure(error)));
    };
}


// WEBPACK FOOTER //
// ./src/actions/users.js